// /app/frontend/src/components/frugal-v2/hooks/useVIPSupport.js
// Independent VIP Support hook for Frugal V2 (70 lines)

import { useState, useEffect, useCallback } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;
const STORAGE_KEY = 'vipSupportToastDismissed';
const TOAST_DELAY_MS = 3000;

export function useVIPSupport() {
  const [showToast, setShowToast] = useState(false);
  const [toastDismissed, setToastDismissed] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState('');

  // Fetch WhatsApp number from backend
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await fetch(`${API}/api/config/public`);
        if (response.ok) {
          const data = await response.json();
          if (data.whatsapp_number) {
            setWhatsappNumber(data.whatsapp_number);
          }
        }
      } catch (error) {
        console.error('Error fetching config:', error);
      }
    };
    fetchConfig();
  }, []);

  // Check if toast was dismissed before
  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (dismissed === 'true') {
      setToastDismissed(true);
    }
  }, []);

  // Show toast after delay
  useEffect(() => {
    if (toastDismissed) return;
    const timer = setTimeout(() => setShowToast(true), TOAST_DELAY_MS);
    return () => clearTimeout(timer);
  }, [toastDismissed]);

  const getWhatsAppUrl = useCallback(() => {
    const phoneNumber = whatsappNumber || '';
    if (!phoneNumber) return '';
    const message = '¡Hola! Necesito ayuda con ZenSaver.';
    const cleanNumber = phoneNumber.replace(/[^\d+]/g, '');
    return `https://wa.me/${cleanNumber}?text=${encodeURIComponent(message)}`;
  }, [whatsappNumber]);

  const openWhatsApp = useCallback(() => {
    const url = getWhatsAppUrl();
    if (url) window.open(url, '_blank', 'noopener,noreferrer');
  }, [getWhatsAppUrl]);

  const dismissToast = useCallback(() => {
    setShowToast(false);
    setToastDismissed(true);
    localStorage.setItem(STORAGE_KEY, 'true');
  }, []);

  const handleToastAction = useCallback(() => {
    openWhatsApp();
    dismissToast();
  }, [openWhatsApp, dismissToast]);

  return { showToast, dismissToast, openWhatsApp, handleToastAction, getWhatsAppUrl };
}

export default useVIPSupport;
